import MenuItem from '@mui/material/MenuItem';
import { Iconify, MenuPopover, NextImage } from '@sdf/base';
import { Styles } from '@t2c/shared-fe';
import { DropdownMenuAction } from '../../@types';

interface DropdownPopoverProps {
  anchorElement: null | HTMLElement;
  onClose: () => void;
  menuActions: DropdownMenuAction[];
  data?: any;
}

export const DropdownPopover: React.FC<DropdownPopoverProps> = ({
  anchorElement,
  menuActions,
  onClose,
  data,
}) => {
  return (
    <MenuPopover
      anchorEl={anchorElement}
      open={Boolean(anchorElement)}
      onClose={onClose}
      disabledArrow
      sx={styles.popover}
    >
      {menuActions.map((menuItem) => {
        const { id, label, onClick, iconifyIcon, imageIcon } = menuItem;
        return (
          <MenuItem
            key={id}
            onClick={() => {
              onClick(data);
              onClose();
            }}
            sx={styles.popoverItem}
          >
            {imageIcon ? (
              <NextImage src={imageIcon} alt="Logo" width={12} height={12} sx={{ mr: 1 }} />
            ) : (
              <Iconify icon={iconifyIcon} sx={styles.icon} />
            )}
            {label}
          </MenuItem>
        );
      })}
    </MenuPopover>
  );
};

const styles: Styles = {
  popover: {
    maxWidth: '147px',
    backgroundColor: (theme) => theme.palette.background.primary,
    padding: '8px 8px',
  },
  popoverItem: {
    color: (theme) => theme.palette.text.primary,
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '18px',
    display: 'flex',
    alignItems: 'center',
    padding: '8px',
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: (theme) => theme.palette.background.activeCard
    }
  },
  icon: {
    height: 12,
    width: 12,
    marginRight: 1,
  },
};
